import { useCustomer } from 'hooks/useSession'
import useCartItems from './useCart'
import { useMemo } from 'react'
import { useOrderState } from './useOrderState'
import CartUtils from '@order/CartUtils'

const useAvailableCredits = () => {
  const customer = useCustomer()
  const { list } = useCartItems()

  const currentDiscounts = useOrderState((s) => s.discounts)

  const usedCredits = useMemo(() => {
    const credits: number[] = []

    const nonFinalOrders = list.filter(
      (item) => !CartUtils.payments.isFinalStatus(item.payment)
    )

    nonFinalOrders.forEach((item) => {
      item.discounts.forEach((d) => {
        if (d.mode === 'credit') {
          // Discounts are negative its easier to work with absolute values
          credits.push(Math.abs(d.discount))
        }
      })
    })

    currentDiscounts.forEach((discount) => {
      if (discount.mode === 'credit') {
        credits.push(Math.abs(discount.discount))
      }
    })

    return credits
  }, [list, currentDiscounts])

  const value = useMemo(() => {
    const credits = {
      total: customer?.credit ?? 0,
      available: customer?.credit ?? 0,
      used: 0,
    }

    usedCredits.forEach((discount) => {
      credits.available = Math.max(0, credits.available - discount)
      credits.used = Math.max(credits.used + discount, credits.total)
    })

    return credits
  }, [usedCredits, customer?.credit])

  return value
}

export default useAvailableCredits
